module.exports = __webpack_public_path__ + "media/amelia-background-video.34a1fe46.mp4";